import * as React from 'react';
import NumberField from '../components/NumberField';
import FormControl from '../FormControl';
import { useMagicItemRules } from '../../../Modules/MagicForm/Hooks/useMagicItemRules';
import { ItemScheme } from '../MagicFormItem';
import InputField from '../components/InputField';
import AddressWhispererField from '../components/AddressWhispererField';

interface MagicFieldTextFieldProps {
	name?: string;
	itemScheme: ItemScheme;
	disabled?: boolean;
	showCharCounter?: boolean;
}

const MagicFieldTextField: React.FC<MagicFieldTextFieldProps> = ({
	itemScheme,
	name,
	disabled,
	showCharCounter,
}) => {
	const { maxLength } = useMagicItemRules(itemScheme);
	const label = itemScheme?.label || itemScheme?.title;
	const settings = itemScheme?.settings;
	const isRequired = settings?.requiredRules ? true : settings?.required;
	const addressLookup = settings?.addressLookup;
	const addressConfig =
		addressLookup && typeof addressLookup === 'object'
			? {
					apiEndpoint: addressLookup.apiUrl,
					queryParamName: addressLookup.queryParamName,
					responseMapping:
						addressLookup.responseMapping ?? addressLookup.fieldMapping,
			  }
			: null;

	let component;
	if (addressConfig) {
		component = (
			<AddressWhispererField
				name={name ?? itemScheme?.key ?? ''}
				isRequired={isRequired}
				placeholder={settings?.placeholder}
				disabled={disabled}
				charactersLimit={maxLength}
				showCharCounter={showCharCounter}
				addressConfig={addressConfig}
			/>
		);
	} else
		switch (itemScheme?.subType || itemScheme?.subtype) {
			case 'number':
				component = (
					<NumberField
						name={name ?? itemScheme?.key}
						suffix={itemScheme?.settings?.suffix}
						min={itemScheme?.settings?.min}
						max={itemScheme?.settings?.max}
						step={itemScheme?.settings?.step}
						placeholder={itemScheme?.settings?.placeholder}
						disabled={disabled}
						charactersLimit={maxLength}
						showCharCounter={showCharCounter}
					/>
				);
				break;
			default:
				component = (
					<InputField
						name={name ?? itemScheme?.key}
						suffix={itemScheme?.settings?.suffix}
						placeholder={itemScheme?.settings?.placeholder}
						disabled={disabled}
						charactersLimit={maxLength}
						showCharCounter={showCharCounter}
					/>
				);
				break;
		}

	return (
		<FormControl
			label={label}
			name={name ?? itemScheme?.key}
			inLine={itemScheme?.inLine}
			isRequired={isRequired}
			hideRequired={itemScheme?.settings?.hideRequired ?? false}>
			{component}
		</FormControl>
	);
};

export default MagicFieldTextField;
